/**
 * c-scroll-arrows
 * gallery-list の prev/next に disabled 制御を後付けで足す共通スクリプト。
 * 対象：c-featured-collections / c-gallery（.c-*__gallery を持つセクション全般）
 * スクロール位置に応じて先頭/末尾で prev/next を disabled 化 → CSS で visibility: hidden。
 */
(function () {
  if (window.__cScrollArrowsInit) return;
  window.__cScrollArrowsInit = true;

  function setupGallery(gallery) {
    if (gallery.dataset.cScrollArrowsInitialized === '1') return;
    gallery.dataset.cScrollArrowsInitialized = '1';

    const scrollable = gallery.querySelector('scrollable-content');
    const prevNext = gallery.querySelector('prev-next-buttons');
    if (!scrollable || !prevNext) return;

    const prevBtn = prevNext.querySelector('button:first-of-type');
    const nextBtn = prevNext.querySelector('button:last-of-type');
    if (!prevBtn || !nextBtn) return;

    const update = () => {
      const max = scrollable.scrollWidth - scrollable.clientWidth;
      const left = Math.abs(scrollable.scrollLeft);
      const noScroll = max <= 1;
      prevBtn.disabled = noScroll || left <= 1;
      nextBtn.disabled = noScroll || left >= max - 1;
    };

    scrollable.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    requestAnimationFrame(update);
  }

  function init() {
    document.querySelectorAll('.c-featured-collections__gallery, .c-gallery__gallery').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
